import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { fetchFoods } from '../../features/Food/foodSlice';
import { Link } from 'react-router-dom';

import HomeProductCard from './HomeProductCard';
import food from '../../utils/data';
function Suggested({ label }) {
  return (
    <div className="lg:px-[150px] px-[25px] py-[10px] ">
      <div className="flex justify-between items-center">
        <p className="text-dark-2 lg:text-h1 text-h2 font-semibold py-[25px]">
          {label}
        </p>
        <Link to="/foods">
          <p className="text-primary-7 lg:text-h5 text-h5 py-[25px]">See All</p>
        </Link>
      </div>

      <div className="flex justify-between space-x-[10px] overflow-x-scroll hideScroll ">
        {food &&
          food
            .slice(2, 6)
            .map((data) => (
              <HomeProductCard
                id={data.id}
                key={data.id}
                foodName={data.foodName}
                restaurantName={data.restaurantName}
                src={data.src}
                waitingTime={data.waitingTime}
                calories={data.calories}
              />
            ))}
      </div>
    </div>
  );
}

export default Suggested;
